import React from "react"

const IframeEmbed = props => {
  const youtubeRegExp = new RegExp(
    "(?:(?:https?://)(?:www)?.?(?:youtu.?be)(?:.com)?/(?:.*[=/])*)([^= &?/\r\n]{8,11})"
  )

  /* If src is a YouTube URL, then make the iframe embed responsive. */
  if (youtubeRegExp.test(props?.src)) {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            padding: 0,
            paddingTop:
              !!props?.height && !!props?.width
                ? (props.height / props.width) * 100 + "%"
                : "56.25%",
          }}
        >
          <iframe
            {...props}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          ></iframe>
        </div>
      </div>
    )
  } else {
    return <iframe {...props}></iframe>
  }
}

export default IframeEmbed
